import axios, { InternalAxiosRequestConfig } from "axios";
import { expireAdminSessionAndRedirect } from "src/utils/adminSession";

export const apiCaller = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});
let networkErrorShown = false;
apiCaller.interceptors.request.use(
  async (
    config: InternalAxiosRequestConfig<any>
  ): Promise<InternalAxiosRequestConfig<any>> => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      return config;
    }
    const header: string = `Bearer ${accessToken}`;
    config.headers["Authorization"] = header;
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

apiCaller.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized / invalid token - force re-login
    if (error.response?.status === 401) {
      expireAdminSessionAndRedirect();
      return Promise.reject(error);
    }

    // Handle club disabled
    if (
      error.response?.status === 403 &&
      error.response?.data?.message
        ?.toLowerCase()
        .includes("club has been disabled")
    ) {
      expireAdminSessionAndRedirect();
    }

    // Handle session expired - check for error flag and message
    if (
      error.response?.data?.error === true &&
      error.response?.data?.message?.toLowerCase().includes("session expired")
    ) {
      expireAdminSessionAndRedirect();
    }

    return Promise.reject(error);
  }
);
